import React, { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "./components/Header.jsx";
import Snowfall from "./components/Snowfall.jsx";
import Footer from "./components/Footer.jsx";
import PageTransition from "./components/PageTransition.jsx";
const Home = lazy(() => import("./pages/Home.jsx"));
const LegalPage = lazy(() => import("./pages/LegalPage.jsx"));
const Services = lazy(() => import("./pages/Services.jsx"));
const Projects = lazy(() => import("./pages/Projects.jsx"));
const About = lazy(() => import("./pages/About.jsx"));
const Advantages = lazy(() => import("./pages/Advantages.jsx"));
const Contact = lazy(() => import("./pages/Contact.jsx"));
const NotFound = lazy(() => import("./pages/NotFound.jsx"));
// Estruturas
const EstruturasIndex = lazy(() =>
  import("./domains/estruturas/pages/Index.jsx")
);
const EstruturasServicos = lazy(() =>
  import("./domains/estruturas/pages/Servicos.jsx")
);
const EstruturasProjetos = lazy(() =>
  import("./domains/estruturas/pages/Projetos.jsx")
);
const EstruturasVantagens = lazy(() =>
  import("./domains/estruturas/pages/Vantagens.jsx")
);
const EstruturasContato = lazy(() =>
  import("./domains/estruturas/pages/Contato.jsx")
);
// Aquecedor
const AquecedorIndex = lazy(() =>
  import("./domains/aquecedor/pages/Index.jsx")
);
const AquecedorServicos = lazy(() =>
  import("./domains/aquecedor/pages/Servicos.jsx")
);
const AquecedorProjetos = lazy(() =>
  import("./domains/aquecedor/pages/Projetos.jsx")
);
const AquecedorVantagens = lazy(() =>
  import("./domains/aquecedor/pages/Vantagens.jsx")
);
const AquecedorContato = lazy(() =>
  import("./domains/aquecedor/pages/Contato.jsx")
);
// Energia
const EnergiaIndex = lazy(() => import("./domains/energia/pages/Index.jsx"));
const EnergiaProjetos = lazy(() =>
  import("./domains/energia/pages/Projetos.jsx")
);
const EnergiaSimulacao = lazy(() =>
  import("./domains/energia/pages/Simulacao.jsx")
);
const EnergiaVantagens = lazy(() =>
  import("./domains/energia/pages/Vantagens.jsx")
);
const EnergiaContato = lazy(() =>
  import("./domains/energia/pages/Contato.jsx")
);

export default function App() {
  const isChristmasTime = new Date().getMonth() === 11;
  const location = useLocation();

  return (
    <div className="app-shell">
      <Header christmasTheme={isChristmasTime} />
      {isChristmasTime && <Snowfall />}
      <Suspense fallback={<div className="container py-8">Carregando...</div>}>
        <AnimatePresence mode="wait" initial={false}>
          <PageTransition key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<Services />} />
          <Route path="/projetos" element={<Projects />} />
          <Route path="/quem-somos" element={<About />} />
          <Route path="/vantagens" element={<Advantages />} />
          <Route path="/contato" element={<Contact />} />
          {/* Estruturas Galvanizadas */}
          <Route path="/estruturas" element={<EstruturasIndex />} />
          <Route path="/estruturas/servicos" element={<EstruturasServicos />} />
          <Route path="/estruturas/projetos" element={<EstruturasProjetos />} />
          <Route
            path="/estruturas/vantagens"
            element={<EstruturasVantagens />}
          />
          <Route path="/estruturas/contato" element={<EstruturasContato />} />
          {/* Aquecedor Solar */}
          <Route path="/aquecedor-solar" element={<AquecedorIndex />} />
          <Route
            path="/aquecedor-solar/servicos"
            element={<AquecedorServicos />}
          />
          <Route
            path="/aquecedor-solar/projetos"
            element={<AquecedorProjetos />}
          />
          <Route
            path="/aquecedor-solar/vantagens"
            element={<AquecedorVantagens />}
          />
          <Route
            path="/aquecedor-solar/contato"
            element={<AquecedorContato />}
          />
          {/* Energia Solar */}
          <Route path="/energia-solar" element={<EnergiaIndex />} />
          <Route path="/energia-solar/projetos" element={<EnergiaProjetos />} />
          <Route
            path="/energia-solar/simulacao"
            element={<EnergiaSimulacao />}
          />
          <Route
            path="/energia-solar/vantagens"
            element={<EnergiaVantagens />}
          />
          <Route path="/energia-solar/contato" element={<EnergiaContato />} />
          <Route
            path="/politica-cookies"
            element={
              <LegalPage
                src="/politica-cookies.html"
                title="Política de Cookies"
              />
            }
          />
          <Route
            path="/politica-privacidade"
            element={
              <LegalPage
                src="/politica-privacidade.html"
                title="Política de Privacidade"
              />
            }
          />
          <Route
            path="/termos-uso"
            element={<LegalPage src="/termos-uso.html" title="Termos de Uso" />}
          />
          <Route
            path="/aceite-ciencia"
            element={
              <LegalPage
                src="/aceite-ciencia.html"
                title="Aceite e Ciência do Uso de Informações"
              />
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
          </PageTransition>
        </AnimatePresence>
      </Suspense>
      <Footer />
    </div>
  );
}
